import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotifyList from '../../_SharedWorkflow/Notify/List';
import NotifyCreate from '../../_SharedWorkflow/Notify/Create';
import NotifyDetail from '../../_SharedWorkflow/Notify/Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    ResponseRequiredDate: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;
    if (!clauses) {
        if (wfid === 15 && placeholdersQA.PmClauses) {
            clauses = placeholdersQA.PmClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 17 && placeholdersQA.SupervisorClauses) {
            clauses = placeholdersQA.SupervisorClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 16 && placeholdersQA.SupplierClauses) {
            clauses = placeholdersQA.SupplierClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 57 && placeholdersQA.ClientClauses) {
            clauses = placeholdersQA.ClientClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 58 && placeholdersQA.PmToSupervisorClauses) {
            clauses = placeholdersQA.PmToSupervisorClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 59 && placeholdersQA.PmToClientClauses) {
            clauses = placeholdersQA.PmToClientClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 60 && placeholdersQA.SupervisorToPmToClauses) {
            clauses = placeholdersQA.SupervisorToPmToClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 63 && placeholdersQA.PmToPmClauses) {
            clauses = placeholdersQA.PmToPmClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 64 && placeholdersQA.ClientToClientClauses) {
            clauses = placeholdersQA.ClientToClientClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 65 && placeholdersQA.SupplierToSupplierClauses) {
            clauses = placeholdersQA.SupplierToSupplierClauses.values.filter(item => item.isActive === true);
        }
        else if (wfid === 66 && placeholdersQA.SupervisorToSupervisorClauses) {
            clauses = placeholdersQA.SupervisorToSupervisorClauses.values.filter(item => item.isActive === true);
        }
    }

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Type = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
    fields.Type.clauses = clauses;
    if (workflowItem.replyEnabled) {
        fields.ResponseRequiredDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.RESPONSE_REQUIRED"], required: false };
    }
    fields.Details = { visible: true, label: workflowItem.notificationName, required: true };

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };
    const workflowItem = workflowsQA[wfid];

    let replyOptions = workflowItem.replyOptions;
    if (!replyOptions && placeholdersQA.ReplyOptions) {
        replyOptions = placeholdersQA.ReplyOptions.values.filter(item => item.isActive === true);
    }

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}

class NotificationsRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
        this.replyingParty = props.workflowItem.replyingParty;

        if (props.mode === 'PM') {
            this.notificationType = 'PMN';
            this.documentType = 'DocumentPMN';
        }
        else if (props.mode === 'SUPERVISOR') {
            this.notificationType = 'SN';
            this.documentType = 'DocumentSN';
        }
        else if (props.mode === 'SUPPLIER') {
            this.notificationType = 'CN';
            this.documentType = 'DocumentCN';
        }
        else if (props.mode === 'CLIENT') {
            this.notificationType = 'ClientNotification';
            this.documentType = 'DocumentClientNotification';
        }
        else if (props.mode === 'PM_SUPERVISOR') {
            this.notificationType = 'PmToSupvNotification';
            this.documentType = 'DocumentPmToSupvNotification';
        }
        else if (props.mode === 'PM_CLIENT') {
            this.notificationType = 'PmToClientNotification';
            this.documentType = 'DocumentPmToClientNotification';
        }
        else if (props.mode === 'SUPERVISOR_PM') {
            this.notificationType = 'SupvToPmNotification';
            this.documentType = 'DocumentSupvToPmNotification';
        }
        else if (props.mode === 'PM_PM') {
            this.notificationType = 'PmToPmNotification';
            this.documentType = 'DocumentPmToPMNotification';
        }
        else if (props.mode === 'CLIENT_CLIENT') {
            this.notificationType = 'ClientToClientNotification';
            this.documentType = 'DocumentClientToClientNotification';
        }
        else if (props.mode === 'SUPPLIER_SUPPLIER') {
            this.notificationType = 'SupplierToSupplierNotification';
            this.documentType = 'DocumentSuppierToSupplierNotification';
        }
        else if (props.mode === 'SUPERVISOR_SUPERVISOR') {
            this.notificationType = 'SupvToSupvNotification';
            this.documentType = 'DocumentSupvToSupvNotification';
        }
        else if (props.mode === 'SUPPLIER_SUPERVISOR') {
            this.notificationType = props.workflowItem.config.currentModelType;
            this.documentType = 'Document' + props.workflowItem.config.currentModelType;
        }
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<NotifyList
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                        />}

                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <NotifyCreate
                                    {...this.props}
                                    title={this.notificationName}
                                    abbreviation={this.abbreviation}
                                    notificationType={this.notificationType}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<NotifyDetail
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            documentType={this.documentType}
                            notifyUserFilter={workflowItem.notifyUserFilter}
                        />}
                    />
                </Routes>
            </>
        );
    }
}



export default (NotificationsRouter);